import React, { useState, useEffect, Fragment } from "react";

const UserewardTable = (
    dataArr,
    handleDelRewards,
    handleEditClick,
    onClickToggleFromTable
) => {
  const [thead] = useState(["Reward", "Action"]);
  const [trow, setTrow] = useState([]);

  useEffect(() => {
    let trowArr = dataArr.map((el) => {
      return {
        "Reward": el.rewardType,
        Action: (
          <Fragment>
            <i
              className="fas fa-edit ml-4"    
              style={{ marginRight: "10px", cursor: "pointer" }}          
              onClick={() => {
                handleEditClick(el, el.rewardId);
              
             }}
            ></i>
            <i
              className="fas fa-trash"
              onClick={() => handleDelRewards(el.rewardId)}
            ></i>
            
          </Fragment>
        ),
      };
    });

     setTrow(trowArr);
  }, [
    dataArr,
    handleDelRewards,
    handleEditClick,
    onClickToggleFromTable
  ]);

  return { thead, trow };
};

export default UserewardTable;